<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content>
  <p class="messageCntr">{{ message }}</p>
  @if (data?.showDeleteContents) {
    <mat-slide-toggle [(ngModel)]="deleteContents" i18n>Verwijder ook alle inhoud van deze map</mat-slide-toggle>
    @if (deleteContents) {
      <p>
        <strong i18n>Extra waarschuwing: weet je zeker dat je alle bestanden en submappen wilt verwijderen?</strong>
      </p>
    } @else {
      <p i18n>De selectie bevat mappen met inhoud. Schakel het verwijderen van de inhoud in om door te gaan.</p>
    }
  }
  @if (password && contentsConfirmed) {
    <p i18n>Herhaal het volgende woord voordat dit definitief verwijderd wordt: "<strong id="password">{{ password }}</strong>"</p>

    <mat-form-field color="accent" appearance="fill">
      <mat-label i18n>Voer het woord in</mat-label>
      <input
        matInput
        appAutoFocus
        [(ngModel)]="passwordInput"
        (keydown.enter)="confirmed()"
        (ngModelChange)="inputChanged($event)"
      >
    </mat-form-field>
  }
</div>
<div mat-dialog-actions>
  <button mat-stroked-button color="warn" [disabled]="!canConfirm" (click)="confirmed()" i18n>Ja!</button>
  <button mat-flat-button color="accent" mat-dialog-close i18n>Nee</button>
</div>
